import { _PopoverCallStackSaySorry } from '~/modules/SDK/FrError/components/_PopoverCallStackSaySorry';
export const FrError = {
    boundary: {
        PopoverCallStackSaySorry: _PopoverCallStackSaySorry,
    },
};
